'use client';

import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useAuth } from '@/lib/authContext';
import OnboardingTour from '@/components/OnboardingTour';

export default function OnboardingWrapper({ children }: { children: React.ReactNode }) {
  const { user, customerData, loading } = useAuth();
  const pathname = usePathname();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [onboardingCompleted, setOnboardingCompleted] = useState(false);

  useEffect(() => {
    // Don't show onboarding if we're on the login page - wait until user is forwarded
    const isOnLoginPage = pathname === '/login';
    if (isOnLoginPage) {
      setShowOnboarding(false);
      return;
    }

    // Check if user is logged in and hasn't signed up for marketplace yet
    if (!loading && user && customerData !== undefined) {
      if (customerData && !customerData.signedUp) {
        // Small delay after leaving login page to ensure navigation is complete
        const timer = setTimeout(() => {
          setShowOnboarding(true);
        }, 100);
        return () => clearTimeout(timer);
      } else {
        setShowOnboarding(false);
      }
    } else if (!loading && !user) {
      setShowOnboarding(false);
    }
  }, [user, customerData, loading, pathname]);

  const handleOnboardingComplete = () => {
    setShowOnboarding(false);
    setOnboardingCompleted(true);
    // Refresh customer data by reloading (auth context will update)
    if (user) {
      window.location.reload();
    }
  };

  return (
    <>
      {children}
      {showOnboarding && !onboardingCompleted && (
        <OnboardingTour onComplete={handleOnboardingComplete} />
      )}
    </>
  );
}


